import React from "react";
import "../../StylesCSS/ButtonsLayout.css";
import { ImportExport, Build, Edit, Description } from "@mui/icons-material"; // Import des icônes
import { useNavigate } from "react-router-dom"; // Import de useNavigate

const PageLayout = () => {
  const navigate = useNavigate(); // Initialisation de useNavigate

  const handleSectionChange = (route) => {
    navigate(`/${route}`); // Navigation vers la route correspondante
  };

  return (
    <div>
      <div style={{ marginTop: "60px", marginBottom: "20px" }}></div>
      <div style={{ maxWidth: "600px", margin: "auto", textAlign: "right" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center", // Centrage horizontal
            alignItems: "center",

            backgroundColor: "#B8B8B8",
            padding: "16px",
            borderRadius: "8px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
            direction: "rtl",
            fontFamily: "Arial, sans-serif",
            fontSize: "22px",
            fontWeight: "bold",
            height: "80px",
            gap: "20px",
          }}
        >
          {/* Carré à droite (début de ligne en arabe) */}
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#218C91",
              borderRadius: "2px",
            }}
          ></div>

          {/* Texte arabe centré */}
          <span>تدبير مجالس الأقســــام للتالثة اعدادي</span>

          {/* Carré à gauche (fin de ligne en arabe) */}
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#218C91",
              borderRadius: "2px",
            }}
          ></div>
        </div>
        <br></br>
        <h2 style={{ textAlign: "right" }}> : تدبير مجالس الأقســــام </h2>
        <div className="buttons-container">
          <div className="button-group">
            <button
              className="btn btn-left"
              onClick={() => handleSectionChange("ImportFileExcel")}
              style={{
                backgroundColor: "#218C91",
                color: "white",
                padding: "10px 20px",
                margin: "10px 0",
                borderRadius: "8px",
                border: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ImportExport style={{ marginRight: "8px" }} />{" "}
              {/* Icône pour importation */}
              استيراد النتائج
            </button>
            <button
              className="btn btn-left"
              onClick={() => handleSectionChange("PageLayout3")}
              style={{
                backgroundColor: "#218C91",
                color: "white",
                padding: "10px 20px",
                margin: "10px 0",
                borderRadius: "8px",
                border: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Description style={{ marginRight: "8px", fontSize: "24px" }} />{" "}
              {/* Icône pour محاضر التوجيه */}
              محاضر التوجيه
            </button>
          </div>
          <div className="button-group">
            <button
              className="btn btn-right"
              onClick={() => handleSectionChange("PageLayout2")}
              style={{
                backgroundColor: "#218C91",
                color: "white",
                padding: "10px 20px",
                margin: "10px 0",
                borderRadius: "8px",
                border: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Build style={{ marginRight: "8px" }} />{" "}
              {/* Icône pour préparation des données */}
              تهيء المعطيات
            </button>

            <button
              className="btn btn-right"
              onClick={() => handleSectionChange("StudentSelector")}
              style={{
                backgroundColor: "#218C91",
                color: "white",
                padding: "10px 20px",
                margin: "10px 0",
                borderRadius: "8px",
                border: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Edit style={{ marginRight: "8px" }} />{" "}
              {/* Icône pour saisir une décision */}
              مسك القرار
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageLayout;
